<div class="container-view-questionnaire" *ngIf="dimension.length > 0; else noQuestions">
  <div class="container-top">
    <header>
      <h1>{{ 'inclusion-index.trainee-assessment-title' | translate }}</h1>
      <p>{{ 'inclusion-index.trainee-assessment-subtitle' | translate }}</p>
    </header>
  </div>

  <div class="container-bottom">
    <mat-stepper orientation="vertical" [linear]="true">
      <mat-step *ngFor="let dim of dimension; let i = index" [stepControl]="dimensionForms[i]">
        <form [formGroup]="dimensionForms[i]">
          <ng-template matStepLabel>
            {{ 'common.dimension' | translate }}: {{ dim.dimensionCode | translate }}
          </ng-template>

          <div *ngFor="let q of dim.questions; let qIndex = index" class="question-block">
            <label>{{ q.questionCode | translate }}</label>
            <mat-radio-group formControlName="question{{ qIndex + 1 }}" class="radio-group">
               <mat-radio-button *ngFor="let opt of [1,2,3,4,5]" [value]="opt">
                {{ opt }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="navigation-buttons">
            <button mat-button matStepperPrevious *ngIf="i !== 0">{{ 'common.back' | translate }}</button>
            <button mat-button matStepperNext *ngIf="i !== dimension.length - 1">{{ 'common.next' | translate }}</button>
            <button mat-button color="primary" (click)="submit()" *ngIf="i === dimension.length - 1">{{ 'common.submit' | translate }}</button>
           </div>
        </form>
      </mat-step>
    </mat-stepper>
  </div>
</div>

<ng-template #noQuestions>
  <p>{{ 'view-questionnaire-trainee.no-questions' | translate }}</p>
</ng-template>
